<template>
  <base-dialog @cancel="cancelDialog" :width="900">
    <div slot="header">{{ isCloneMode ? $t('table.action.clone') : (type === 'create' ? $t('common.create') : $t('table.action.modify')) }}</div>
    <div slot="body">
      <a-form-model
        v-bind="formItemLayout"
        ref="form"
        class="mt-3"
        :model="form"
        :rules="rules">
        <!-- 名称 -->
        <a-form-model-item :label="$t('table.title.name')" prop="name" v-bind="formItemLayout">
          <a-input v-model="form.name" :placeholder="$t('common.tips.input', [$t('table.title.name')])" :disabled="type === 'update' && !isCloneMode" />
        </a-form-model-item>
        <!-- 策略 -->
        <a-form-model-item :label="$t('bill.sharing_policy')" v-if="!isCloneMode">
          <div class="d-flex align-items-center mt-2" v-for="(item, index) in form.rules" :key="index">
            <a-card class="w-100">
              <a-form-model-item
                v-bind="formItemLayoutSub"
                :prop="`rules.${index}.match_project_ids`"
                :rules="rules.match_project_ids">
                <span slot="label">
                  {{ $t('bill.sharing_source') }}
                  <!-- <help-tooltip :text="$t('bill.sharing_source.project_tooltip')" /> -->
                </span>
                <base-select
                  resource="projects"
                  v-model="item.match_project_ids"
                  remote
                  :params="{...projectParams, $t: `origin_${index}`}"
                  :select-props="{mode: 'multiple', placeholder: $t('common.tips.select', [$t('bill.sharing_source')])}"
                  :extraOpts="extraSourceProjects"
                  @change="(val) => selectedChange(val, 'match_project_ids', index)">
                  <template #optionLabelTemplate="{ item }">
                    <span>{{item.name}}</span>
                  </template>
                </base-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('bill.sharing_origin_project_res_type')" v-bind="formItemLayoutSub" :prop="`rules.${index}.field`" :rules="rules.field"
                :extra="$t('bill.sharing_origin_project_res_type_desc')">
                <base-select
                  v-model="item.field"
                  :options="shareFieldOpts"
                  :select-props="{placeholder: $t('common.tips.select', [$t('bill.sharing.origin_project_type')])}"
                  @change="(val) => selectedChange(val, 'field', index)" />
              </a-form-model-item>
              <a-form-model-item
                v-if="item.field !== '__any__'"
                :label="item.field === 'resource_type' ? $t('bill.text_73') : item.field === 'origin_res_type' ? $t('bill.sharing.origin_res_type') : $t('bill.sharing.product_detail_code')"
                :rules="rules.origin"
                :prop="`rules.${index}.origin`" v-bind="formItemLayoutSub">
                <base-select
                  :options="transOriginOpts(item.field === 'resource_type' ? resourceTypeOpts : item.field === 'origin_res_type' ? originResTypeOpts : productDetailCodeOpts, item.field)"
                  v-model="item.origin"
                  filterable
                  :select-props="{mode: 'multiple', loading: resourceLoading, placeholder: $t('common.tips.select', [$t('bill.share_resource_type')])}"
                  @change="(val) => selectedChange(val, 'origin', index)" />
              </a-form-model-item>
              <a-form-model-item
                :rules="rules.share_method"
                :prop="`rules.${index}.share_method`"
                v-bind="formItemLayoutSub"
                :label="$t('bill.share_method')"
                :extra="$t('bill.sharing_target_project_rate_desc')">
                <a-select
                  v-model="item.share_method">
                  <a-select-option value="even">{{$t('bill.share_equally')}}</a-select-option>
                  <a-select-option value="proportional">{{$t('bill.share_proportional')}}</a-select-option>
                  <a-select-option value="projectpercent">{{$t('bill.share_project_percent')}}</a-select-option>
                  <a-select-option value="projecttag">{{$t('bill.share_project_tag')}}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item
                v-if="item.share_method === 'projecttag'"
                :label="$t('bill.sharing_target_tag')"
                :rules="rules.target_tag"
                :prop="`rules.${index}.target_tag`"
                v-bind="formItemLayoutSub">
                <a-col v-if="item.target_tag && item.target_tag.tag_key" class="d-flex align-items-center flex-wrap">
                  <a-tag v-for="(l,idx) in item.target_tag.tag_values" :key="idx" class="mb-1"><span>{{ item.target_tag.tag_key.replace('user:', '').replace('ext:', '') }}:{{ l.tag_value }}</span><span class="ml-2">{{ l.percent + '%' }}</span></a-tag>
                  <a-button type="link" @click="setTag(item, index)">{{ $t('bill.text_165') }}</a-button>
                </a-col>
                <a-button v-else type="link" class="p-0" @click="setTag(item, index)">{{ $t('bill.click_to_set') }}</a-button>
              </a-form-model-item>
              <a-form-model-item
                v-else-if="item.share_method === 'projectpercent'"
                :label="$t('bill.share_project_percent')"
                :rules="rules.target_project_percent"
                :prop="`rules.${index}.target_perject_percent`"
                v-bind="formItemLayoutSub">
                <a-col v-if="item.target_project_percent && item.target_project_percent.length" class="d-flex align-items-center flex-wrap">
                  <a-tag v-for="(l,idx) in item.target_project_percent" :key="idx" class="mb-1"><span>{{ l.project_name }}</span>:<span class="ml-2">{{ l.percent + '%' }}</span></a-tag>
                  <a-button type="link" @click="setProjectPercent(item, index)">{{ $t('bill.text_165') }}</a-button>
                </a-col>
                <a-button v-else type="link" class="p-0" @click="setProjectPercent(item, index)">{{ $t('bill.click_to_set') }}</a-button>
              </a-form-model-item>
              <a-form-model-item
                v-else
                :rules="rules.target"
                :prop="`rules.${index}.target`"
                v-bind="formItemLayoutSub">
                <span slot="label">
                  {{ $t('bill.sharing_target_project') }}
                  <help-tooltip :text="`${$t('bill.sharing_target.project_tooltip')}，${$t('bill.sharing_target.project_tooltip1')}`" />
                </span>
                <a-col class="d-flex">
                  <base-select
                    resource="projects"
                    v-model="item.target"
                    :params="{...projectParams, $t: `target_${index}` }"
                    :select-props="{mode: 'multiple', placeholder: $t('common.tips.select', [$t('bill.share_target_project')])}"
                    style="flex: 1 1 auto;width:0"
                    :extraOpts="extraProjects"
                    remote
                    @change="(val) => selectedChange(val, 'target', index)">
                    <template #optionLabelTemplate="{ item }">
                      <span>{{item.name}}</span>
                    </template>
                  </base-select>
                  <!-- <div v-if="item.target.length" class="share-label ml-2">
                    <a-select
                      v-if="item.target.includes('__others__') || item.target.includes('other_projects_of_account') || item.target.length > 1"
                      v-model="item.share_method"
                      style="width:140px">
                      <a-select-option value="even">{{$t('bill.share_equally')}}</a-select-option>
                      <a-select-option value="proportional">{{$t('bill.share_proportional')}}</a-select-option>
                    </a-select>
                    <div v-else class="share-text">100%</div>
                  </div> -->
                </a-col>
              </a-form-model-item>
            </a-card>
            <div style="flex: 0 0 48px;margin-left:5px;transform:translateY(-12px);display:flex;flex-direction:column;gap:8px">
              <a-button v-if="form.rules.length > 1" shape="circle" icon="minus" size="small" @click="deletePolicy(index)" />
              <a-button shape="circle" type="primary" icon="plus" size="small" @click="addPolicyAfter(index)" />
            </div>
          </div>
        </a-form-model-item>
        <!-- 时间 -->
        <a-form-model-item :label="$t('bill.effective_start_time')" prop="date" v-bind="formItemLayout">
          <!-- <a-date-picker v-model="form.date" valueFormat="YYYYMMDD" format="YYYY-MM" /> -->
          <a-month-picker v-model="form.date" format="YYYY-MM" :disabled="type === 'update' && !isCloneMode" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { getNameFilter, getDescriptionFilter, getProjectDomainFilter } from '@/utils/common/tableFilter'
import { getProjectDomainTableColumn } from '@/utils/common/tableColumn'
import { getBillResourceTypeLabel } from '@Bill/utils'

export default {
  name: 'BillSharingCreateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const form = this.genInitForm(this.params.type || 'create')
    return {
      loading: false,
      resourceLoading: false,
      type: this.params.type || 'create',
      isCloneMode: this.params.isClone || false,
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      formItemLayoutSub: {
        wrapperCol: {
          span: 17,
        },
        labelCol: {
          span: 7,
        },
      },
      shareFieldOpts: [
        {
          id: '__any__',
          name: this.$t('bill.all_resources'),
        },
        {
          id: 'resource_type',
          name: this.$t('bill.text_73'),
        },
        {
          id: 'origin_res_type',
          name: this.$t('bill.sharing.origin_res_type'),
        },
        {
          id: 'product_detail_code',
          name: this.$t('bill.sharing.product_detail_code'),
        },
      ],
      form: form || {
        rules: [
          {
            field: '__any__',
            match_project_ids: ['default'],
            origin: ['__others__'],
            target: ['__others__'],
            share_method: 'even',
            target_tag: {},
            target_project_percent: [],
          },
        ],
        date: this.$moment(),
      },
      rules: {
        name: [
          { required: true, message: `${this.$t('common.placeholder')}${this.$t('common.name')}` },
          { validator: this.$validate('resourceName') },
        ],
        rules: [{ required: !this.params.isClone, message: this.$t('bill.sharing_policy_empty') }],
        match_project_ids: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.sharing_source')]) }],
        share_method: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.share_method')]) }],
        origin: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.share_resource_type')]) }],
        target: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.share_target_project')]) }],
        target_tag: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.project_tag_value_percent')]), validator: this.validateProjectTag }],
        target_project_percent: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.project_with_percent')]), validator: this.validateProjectPercent }],
        date: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.effective_start_time')]) }],
        field: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.sharing.origin_project_type')]) }],
      },
      resourceTypeOpts: [
        {
          id: '__others__',
          name: this.$t('bill.all'),
        },
      ],
      originResTypeOpts: [
        {
          id: '__others__',
          name: this.$t('bill.all'),
        },
      ],
      productDetailCodeOpts: [
        {
          id: '__others__',
          name: this.$t('bill.all'),
        },
      ],
      brandParams: {
        scope: this.$store.getters.scope,
        cloud_env: 'public',
      },
      projectListSelectProps: {
        list: this.$list.createList(this, {
          id: this.id,
          resource: 'projects',
          apiVersion: 'v1',
          getParams: () => {
            return {
              scope: this.$store.getters.scope,
            }
          },
          filterOptions: {
            name: getNameFilter(),
            description: getDescriptionFilter(),
            project_domain: getProjectDomainFilter(),
          },
        }),
        columns: [
          {
            field: 'name',
            title: this.$t('table.title.name'),
            showOverflow: 'title',
          },
          {
            field: 'description',
            title: this.$t('system.text_193'),
            showOverflow: 'title',
          },
          getProjectDomainTableColumn(),
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'isDomainMode', 'scope']),
    projectParams () {
      const ret = {
        scope: this.$store.getters.scope,
        limit: 20,
      }
      const { data = {} } = this.params
      const { domain_id, shared_domains = [] } = data
      const domainList = []
      if (domain_id) {
        domainList.push(domain_id)
      }
      shared_domains.map(item => {
        domainList.push(item.id)
      })
      if (domainList.length && this.params.data.id !== 'extdb') {
        ret.filter = `domain_id.in(${domainList.map(item => `'${item}'`).join(',')})`
      }
      return ret
    },
    extraProjects () {
      const ret = [
        { id: 'other_projects_of_account', name: this.$t('bill.sharing_source.other_projects_of_account') },
        { id: '__others__', name: this.$t('bill.sharing_source.projects_of_other_account') },
      ]
      if (this.type === 'update') {
        const { rules_detail = [] } = this.params.row || {}
        rules_detail.map(item => {
          const { target_projects = [] } = item
          target_projects.map(l => {
            if (!ret.some(item => item.id === l.id)) {
              ret.push(l)
            }
          })
        })
      }
      return ret
    },
    extraSourceProjects () {
      const ret = [
        { id: 'default', name: this.$t('bill.sharing_source.default') },
        { id: 'projects_of_account', name: this.$t('bill.sharing_source.projects_of_account') },
      ]
      if (this.type === 'update') {
        const { rules_detail = [] } = this.params.row || {}
        rules_detail.map(item => {
          const { match_projects = [] } = item
          match_projects.map(l => {
            if (!ret.some(item => item.id === l.id)) {
              ret.push(l)
            }
          })
        })
      }
      return ret
    },
    isAddShow () {
      let show = true
      const { rules = [] } = this.form
      let selected = []
      rules.map(item => {
        if (item.origin) {
          if (item.origin.includes('__others__')) {
            show = false
          } else {
            selected = [...selected, ...item.origin]
          }
        }
      })
      const origins = this.originOpts.filter(item => item.id !== '__others__')
      return show && origins.length !== selected.length
    },
  },
  watch: {
    'form.type': function () {
      this.fetchData()
      this.clearOriginSelected()
    },
  },
  created () {
    this.$pM = new this.$Manager('projects')
    this.resourceM = new this.$Manager('payment_bills', 'v1')
    this.fetchData()
  },
  methods: {
    transOriginOpts (opts, type) {
      if (!Array.isArray(opts)) return []
      return opts.map(item => {
        const ret = R.clone(item)
        if (item.id !== '__others__') {
          return {
            id: item.id,
            name: type === 'resource_type' ? this.resourceTypeFormat(item) : item.name,
          }
        }
        ret.name = this.$t('bill.all')
        return ret
      })
    },
    setProjectPercent (data, index) {
      this.createDialog('SharingSetProjectPercentDialog', {
        param: R.clone(data || {}),
        update: (value) => {
          this.$set(this.form.rules[index], 'target_project_percent', R.clone(value))
          this.$nextTick(() => {
            this.$refs.form.validateField('rules.' + index + '.target_project_percent')
          })
        },
      })
    },
    validateProjectTag (rule, value, callback) {
      const index = parseInt(rule.field.replace('rules.', '').replace('.target_tag', ''))
      const target = this.form.rules[index]
      if (target.target_tag && target.target_tag.tag_key) {
        callback()
      } else {
        callback(new Error(this.$t('common.tips.select', [this.$t('bill.project_tag_value_percent')])))
      }
    },
    validateProjectPercent (rule, value, callback) {
      const index = parseInt(rule.field.replace('rules.', '').replace('.target_project_percent', ''))
      const target = this.form.rules[index]
      if (target.target_project_percent.every(item => item.project_id)) {
        callback()
      } else {
        callback(new Error(this.$t('common.tips.select', [this.$t('bill.project_with_percent')])))
      }
    },
    getDate (str) {
      return str ? this.$moment(`${str.substr(0, 4)}-${str.substr(4, 2)}-${str.substr(6, 2)}`) : this.$moment()
    },
    genInitForm (type) {
      if (type === 'create' && !this.params.isClone) return null
      const row = this.params.row || {}
      const { rules_detail = [], date = '', sharing = '' } = row
      let cloneName = sharing || ''
      if (this.params.isClone && cloneName) {
        cloneName = `${cloneName}-copy`
      }
      const form = {
        name: this.params.isClone ? cloneName : sharing,
        type: this.params.resource_type || 'origin_res_type',
        rules: [],
        date: this.params.isClone ? this.$moment() : this.getDate(date + ''),
      }
      if (this.params.isClone) {
        // 克隆模式下，复制原策略规则
        if (rules_detail && rules_detail.length) {
          rules_detail.map(item => {
            const row = {}
            // match_project_ids
            if (!item.match_source) {
              row.match_project_ids = ['default']
            } else if (item.match_source === 'projects_of_account') {
              row.match_project_ids = ['projects_of_account']
            } else if (item.match_source === 'projects') {
              row.match_project_ids = [...(item.match_project_ids || [])]
            }
            // origin
            if (item.field === '__any__') {
              row.field = '__any__'
              row.origin = ['__others__']
            } else {
              row.field = item.field
              row.origin = [...(item.values || [])]
            }
            // target
            if (item.target_project_tag_key) {
              const target_tag = {
                tag_key: item.target_project_tag_key,
                tag_values: [],
              }
              const { target_project_tag_value_percentage = {} } = item
              Object.keys(target_project_tag_value_percentage).map(value => {
                target_tag.tag_values.push({ tag_value: value, percent: target_project_tag_value_percentage[value] * 100 })
              })
              row.target_tag = target_tag
            } else if (item.target_project_ids_percentage) {
              const { target_project_ids_percentage = {}, target_projects = [] } = item
              const keys = Object.keys(target_project_ids_percentage)
              const ret = []
              keys.map(id => {
                const t = target_projects.filter(l => l.id === id)
                const name = t.length ? t[0].name : id
                ret.push({
                  project_id: id,
                  project_name: name || id,
                  percent: (target_project_ids_percentage[id] || 0) * 100,
                })
              })
              row.target_project_percent = ret
            } else if (item.share_target === 'projects_of_account') {
              row.target = ['__others__']
            } else if (item.share_target === 'other_projects_of_account') {
              row.target = ['other_projects_of_account']
            } else if (item.share_target === 'projects') {
              row.target = [...(item.target_project_ids || [])]
            }
            row.share_method = item.share_method || 'even'
            if (item.target_project_tag_key) {
              row.share_method = 'projecttag'
            }
            if (item.target_project_ids_percentage) {
              row.share_method = 'projectpercent'
            }
            form.rules.push(row)
          })
        }
        return form
      }
      if (type === 'update' && !this.params.isClone) {
        rules_detail.map(item => {
          const row = {}
          // match_project_ids
          if (!item.match_source) {
            row.match_project_ids = ['default']
          } else if (item.match_source === 'projects_of_account') {
            row.match_project_ids = ['projects_of_account']
          } else if (item.match_source === 'projects') {
            row.match_project_ids = [...(item.match_project_ids || [])]
          }
          // origin
          if (item.field === '__any__') {
            row.field = '__any__'
            row.origin = ['__others__']
          } else {
            row.field = item.field
            row.origin = [...(item.values || ['__others__'])]
          }
          // target
          if (item.target_project_tag_key) {
            const target_tag = {
              tag_key: item.target_project_tag_key,
              tag_values: [],
            }
            const { target_project_tag_value_percentage = {} } = item
            Object.keys(target_project_tag_value_percentage).map(value => {
              target_tag.tag_values.push({ tag_value: value, percent: target_project_tag_value_percentage[value] * 100 })
            })
            row.target_tag = target_tag
          } else if (item.target_project_ids_percentage) {
            const { target_project_ids_percentage = {}, target_projects = [] } = item
            const keys = Object.keys(target_project_ids_percentage)
            const ret = []
            keys.map(id => {
              const t = target_projects.filter(l => l.id === id)
              const name = t.length ? t[0].name : id
              ret.push({
                project_id: id,
                project_name: name || id,
                percent: (target_project_ids_percentage[id] || 0) * 100,
              })
            })
            row.target_project_percent = ret
          } else if (item.share_target === 'projects_of_account') {
            row.target = ['__others__']
          } else if (item.share_target === 'other_projects_of_account') {
            row.target = ['other_projects_of_account']
          } else if (item.share_target === 'projects') {
            row.target = [...(item.target_project_ids || [])]
          }
          row.share_method = item.share_method || 'even'
          if (item.target_project_tag_key) {
            row.share_method = 'projecttag'
          }
          if (item.target_project_ids_percentage) {
            row.share_method = 'projectpercent'
          }
          form.rules.push(row)
        })
      }
      return form
    },
    projectChange (val, index) {
      this.form.rules[index].target = val
    },
    setTag (data, index) {
      this.createDialog('SharingSetTagDialog', {
        param: R.clone(data.target_tag || {}),
        update: (value) => {
          this.$set(this.form.rules[index], 'target_tag', R.clone(value))
          this.$nextTick(() => {
            this.$refs.form.validateField('rules.' + index + '.target_tag')
          })
        },
      })
    },
    formatterProjectLabel (row) {
      return row.name
    },
    async fetchData () {
      try {
        this.resourceLoading = true
        const ret = []
        ret.push(this.resourceM.get({
          id: 'distinct-field',
          params: {
            admin: this.isAdminMode,
            scope: this.scope,
            field: 'resource_type',
            $t: 1,
            filter: `account_id.in(${this.params.account_id})`,
          },
        }))
        ret.push(this.resourceM.get({
          id: 'distinct-field',
          params: {
            admin: this.isAdminMode,
            scope: this.scope,
            field: 'origin_res_type',
            $t: 2,
            filter: `account_id.in(${this.params.account_id})`,
          },
        }))
        ret.push(this.resourceM.get({
          id: 'distinct-field',
          params: {
            admin: this.isAdminMode,
            scope: this.scope,
            field: 'product_detail_code',
            $t: 3,
            filter: `account_id.in(${this.params.account_id})`,
          },
        }))
        const res = await Promise.all(ret)
        const resourceTypeData = (res[0].data && res[0].data.resource_type) || []
        const originResTypeData = (res[1].data && res[1].data.origin_res_type) || []
        const productDetailCodeData = (res[2].data && res[2].data.product_detail_code) || []
        const commonOpts = [
          {
            id: '__others__',
            name: this.$t('bill.other_resources'),
          },
        ]
        this.resourceTypeOpts = [...commonOpts, ...(resourceTypeData.map(id => ({ id: id, name: id })))].filter(item => item.id)
        this.originResTypeOpts = [...commonOpts, ...(originResTypeData.map(id => ({ id: id, name: id })))].filter(item => item.id)
        this.productDetailCodeOpts = [...commonOpts, ...(productDetailCodeData.map(id => ({ id: id, name: id })))].filter(item => item.id)
        this.resourceLoading = false
      } catch (err) {
        this.resourceLoading = false
        throw err
      }
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid, err) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(err)
          }
        })
      })
    },
    genCreateData () {
      const ret = {
        name: this.form.name,
        provider: this.params.provider,
        rules: [],
        date: this.$moment(this.form.date).startOf('month').format('YYYYMMDD'),
        account_id: this.params.account_id,
      }
      this.form.rules.map(item => {
        const row = {}
        // 分摊源
        row.field = item.field
        if (item.field !== '__any__' && item.origin && item.origin.length && !item.origin.includes('__others__')) {
          row.values = item.origin
        }
        // 分摊目标
        if (item.share_method === 'projecttag') {
          // 按项目标签分摊
          const { target_tag = {} } = item
          const { tag_key = '', tag_values = [] } = target_tag
          const target_project_tag_value_percentage = {}
          tag_values.map(l => {
            target_project_tag_value_percentage[l.tag_value] = (l.percent || 0) / 100
          })
          row.target_project_tag_key = tag_key
          row.target_project_tag_value_percentage = target_project_tag_value_percentage
          row.share_target = 'project_tags_distribution'
        } else if (item.share_method === 'projectpercent') {
          const { target_project_percent = [] } = item
          const target_project_ids_percentage = {}
          const project_ids = []
          target_project_percent.map(l => {
            target_project_ids_percentage[l.project_id] = (l.percent || 0) / 100
            project_ids.push(l.project_id)
          })
          row.target_project_ids_percentage = target_project_ids_percentage
          row.target_project_ids = project_ids
          row.share_target = 'target_project_ids_percentage'
        } else {
          if (item.target && item.target.length === 1 && item.target.includes('__others__')) {
            row.share_target = 'projects_of_account'
          } else if (item.target && item.target.length === 1 && item.target.includes('other_projects_of_account')) {
            row.share_target = 'other_projects_of_account'
          } else {
            row.share_target = 'projects'
            row.target_project_ids = item.target
          }
          if (item.target && (item.target.includes('__others__') || item.target.includes('other_projects_of_account') || item.target.length > 1)) {
            row.share_method = item.share_method
          }
        }
        // 资源类型
        const { match_project_ids = [] } = item
        if (match_project_ids.length) {
          if (match_project_ids[0] === 'default') {
            row.match_source = ''
          } else if (match_project_ids[0] === 'projects_of_account') {
            row.match_source = 'projects_of_account'
          } else {
            row.match_source = 'projects'
            row.match_project_ids = match_project_ids.filter(id => id !== 'default' && id !== 'projects_of_default')
          }
        }
        ret.rules.push(row)
      })
      return ret
    },
    async handleConfirm () {
      this.loading = true
      try {
        const validate = await this.validateForm()
        if (!validate) return
        const data = this.genCreateData()
        if (this.isCloneMode || this.type === 'create') {
          await new this.$Manager('project_sharings').create({
            data,
          })
        } else {
          const ids = this.params.row.id.split(':')
          delete data.name
          delete data.date
          await new this.$Manager('project_sharings').update({
            id: ids[1],
            data,
          })
        }
        this.params.ok && this.params.ok()
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
    addPolicy () {
      this.form.rules.push({
        match_source: 'default',
        match_project_ids: [],
        origin: [],
        target: [],
        share_method: 'even',
        target_tag: {},
        target_project_percent: [],
      })
    },
    addPolicyAfter (index) {
      this.form.rules.splice(index + 1, 0, {
        match_source: 'default',
        match_project_ids: [],
        origin: [],
        target: [],
        share_method: 'even',
        target_tag: {},
        target_project_percent: [],
      })
    },
    deletePolicy (index) {
      this.form.rules = this.form.rules.filter((item, idx) => idx !== index)
    },
    disableOriginItems (index) {
      const { rules = [] } = this.form
      const ret = []
      rules.map((item, idx) => {
        if (idx !== index) {
          item.origin.map(id => { ret.push(id) })
        }
      })
      return ret
    },
    disableTargetItems (index) {
      const { rules = [] } = this.form
      let hasOther = false
      rules.map((item, idx) => {
        if (idx !== index && item.target.includes('__others__')) {
          hasOther = true
        }
      })
      return hasOther ? ['__others__'] : []
    },
    resourceTypeFormat (item) {
      return getBillResourceTypeLabel(item.id)
    },
    async selectedChange (val, type, index) {
      if (val.length) {
        const lastId = val[val.length - 1]
        await this.$nextTick()
        if (type === 'field') {
          this.form.rules[index].origin = ['__others__']
        } else if (type === 'match_project_ids') {
          if (lastId === 'default' && val.length > 1) {
            this.form.rules[index][type] = ['default']
          }
          if (lastId === 'projects_of_account' && val.length > 1) {
            this.form.rules[index][type] = ['projects_of_account']
          }
        } else {
          if (lastId === '__others__' && val.length > 1) {
            this.form.rules[index][type] = ['__others__']
          }
          if ((lastId !== '__others__' && this.form.rules[index][type].includes('__others__')) || (lastId !== 'other_projects_of_account' && this.form.rules[index][type].includes('other_projects_of_account'))) {
            this.form.rules[index][type] = this.form.rules[index][type].filter(key => key !== '__others__' && key !== 'other_projects_of_account')
          }
          if (lastId === 'other_projects_of_account' && val.length > 1) {
            this.form.rules[index][type] = ['other_projects_of_account']
          }
        }
      }
    },
    clearOriginSelected () {
      this.form.rules.map(item => {
        item.origin = item.origin.filter(key => key === '__others__')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.share-label {
  .share-text {
    flex: 0 0 50px;
    width: 50px;
    text-align: center;
    display: inline-block;
    height: 32px;
    padding: 0 5px;
    border: 1px solid #d9d9d9;
    line-height: 31px;
  }
}
</style>
